import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { Column } from 'primereact/column'
import CenterService from '../../../services/centers/center.service.js'
import useHandlerBasicActions from '../../../utils/hooks/useHandlerBasicActions.js'
import DataTableComp from '../../../components/common/data-table/DataTableComp.jsx'
import useModal from '../../../utils/hooks/useModal.js'
import { urlBack } from './utils/center.utils.ts'
import CenterSection from './common/CenterSection.tsx'
import AppButton from '../../../component/common/AppButton.tsx'
import AppToolbar from '../../../component/layout/AppToolbar.tsx'

const CenterWorkers = () => {
  const { formatMessage: msg, formatDate: formatDateInl } = useIntl()

  const { isShowing, toggle } = useModal()
  const { id } = useParams()

  const [currentCenter, setCurrentCenter] = useState()
  const [selectedRowId, setSelectedRowId] = useState()

  const navigate = useNavigate()

  useEffect(() => {
    getCenterData()
  }, [])

  const getCenterData = async () => {
    if (id && id !== 'undefined') {
      const response = await CenterService.getById(id)
      if (response) {
        setCurrentCenter(response.resp)
      }
    }
  }

  const dataFacade = useHandlerBasicActions({
    sortFieldInitial: 'name',
    getAll: ({ filter, sort, limit, skip }) =>
      CenterService?.workers?.getAll({ id, filter, sort, limit, skip }),
  })

  const headerOptions = {
    title: currentCenter?.basicData?.name,
    // searchOptions: dataFacade?.searchOptions,
    handlerHeaderActions: {
      showBackButton: true,
      backButton: () => navigate(urlBack(currentCenter?.centerType)),

      // secondaryButton: () => {
      //     updateInputs({})
      //     toggle()
      // },
      // secondaryButtonText: "button.add",
      // secondaryButtonIcon: "pi-plus"
    },
  }

  const pagerOptions = {
    ...dataFacade?.pagerOptions,
    totalRecords: dataFacade?.data?.total,
  }

  const dataTable = (
    <DataTableComp
      loading={dataFacade?.loading}
      pagerOptions={pagerOptions}
      tableOptions={{
        value: dataFacade?.data?.resp,
        dataKey: '_id',
        editMode: 'row',
        // selectionMode: "single",
        // selection: selectedRowId,
        // onRowSelect: (e) => {
        //     setSelectedRowId(e?.data?._id)
        //     toggle()
        // },
        ...dataFacade?.sortOptions,
      }}
      columns={[
        <Column sortable field="name" header={msg({ id: 'name' })} />,
        <Column sortable field="email" header={msg({ id: 'email' })} />,
        <Column sortable field="phone" header={msg({ id: 'phone' })} />,
      ]}
    />
  )

  return (
    <CenterSection
      toolbar={
        <AppToolbar
          rightSection={[
            <AppButton
              preset="back"
              onClick={() => navigate(urlBack(currentCenter?.centerType))}
            />,
          ]}
        />
      }
    >
      {dataTable}
    </CenterSection>
  )
}

export default CenterWorkers
